<template>
	<div :class="isShow ? 'side-over--active' : ''">
		<div
			class="fixed h-screen w-screen top-0 left-0 bg-black opacity-20 z-30"
			v-if="isShow"
			@click="isShow = false"
		></div>
		<StatisticalTimeTable @close="isShow = false" :id="id" />
	</div>
	<div class="__report-lesson px-12 md-down:px-4 pb-30">
		<div
			class="__report-lesson__header py-10 flex flex-nowrap justify-between items-center"
		>
			<div
				class="__record__title text-neutral-500 font-semibold whitespace-nowrap flex flex-nowrap items-center text-4xl cursor-pointer"
				@click="goToCurrentTimetable"
			>
				<svg
					class="mr-2"
					width="28"
					height="28"
					viewBox="0 0 28 28"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M17.5 7L10.5 14L17.5 21"
						stroke="#94A3B8"
						stroke-width="2"
						stroke-linecap="round"
						stroke-linejoin="round"
					/>
				</svg>
				{{ historyTitle }}
			</div>
			<button
				@click="goToCurrentTimetable"
				type="button"
				class="h-10 button-p btn--ghost text-center whitespace-nowrap w-fit"
			>
				TKB Hiện tại
			</button>
		</div>
		<ScheduleSectionNav />
		<div class="w-full mb-8">
			<div class="border-b border-neutral-200">
				<nav aria-label="Tabs" class="-mb-px flex space-x-8 tabs">
					<div
						v-for="tab in visibleTabs"
						:key="tab.id"
						:class="
							tabSelected === tab.id
								? 'border-b-2 text-yellow-700 border-yellow-500 font-semibold'
								: 'text-neutral-500'
						"
						class="border-transparent hover:text-yellow-700 hover:border-yellow-500 whitespace-nowrap py-3 px-1 border-b-2 cursor-pointer"
						@click="tabSelected = tab.id"
					>
						{{ tab.name }}
					</div>
				</nav>
			</div>
		</div>
		<div class="mb-8" v-if="tabSelected === 0">
			<span
				class="text-sm inline-flex items-center py-1 pl-3 pr-2 rounded-full bg-sienna-100 text-neutral-900 mr-2 shadow-input"
				v-if="filter?.state === 'completed'"
			>
				Thông báo đã gửi
				<button
					type="button"
					class="flex-shrink-0 ml-2 h-4 w-4 rounded-full inline-flex items-center justify-center text-neutral-700 hover:text-neutral-900"
					@click="filterSubmit({ state: '' })"
				>
					<svg width="7" height="7" viewBox="0 0 7 7" fill="none">
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M0.35861 0.35861C0.529464 0.187755 0.806474 0.187755 0.977328 0.35861L3.29297 2.67425L5.60861 0.35861C5.77946 0.187755 6.05647 0.187755 6.22733 0.35861C6.39818 0.529464 6.39818 0.806474 6.22733 0.977328L3.91169 3.29297L6.22733 5.60861C6.39818 5.77946 6.39818 6.05647 6.22733 6.22733C6.05647 6.39818 5.77946 6.39818 5.60861 6.22733L3.29297 3.91169L0.977328 6.22733C0.806474 6.39818 0.529464 6.39818 0.35861 6.22733C0.187755 6.05647 0.187755 5.77946 0.35861 5.60861L2.67425 3.29297L0.35861 0.977328C0.187755 0.806474 0.187755 0.529464 0.35861 0.35861Z"
							fill="currentColor"
						/>
					</svg>
				</button>
			</span>
			<span
				class="text-sm inline-flex items-center py-1 pl-3 pr-2 rounded-full bg-sienna-100 text-neutral-900 mr-2 shadow-input"
				v-if="filter?.state === 'draft'"
			>
				Thông báo nháp
				<button
					type="button"
					class="flex-shrink-0 ml-2 h-4 w-4 rounded-full inline-flex items-center justify-center text-neutral-700 hover:text-neutral-900"
					@click="filterSubmit({ state: '' })"
				>
					<svg width="7" height="7" viewBox="0 0 7 7" fill="none">
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M0.35861 0.35861C0.529464 0.187755 0.806474 0.187755 0.977328 0.35861L3.29297 2.67425L5.60861 0.35861C5.77946 0.187755 6.05647 0.187755 6.22733 0.35861C6.39818 0.529464 6.39818 0.806474 6.22733 0.977328L3.91169 3.29297L6.22733 5.60861C6.39818 5.77946 6.39818 6.05647 6.22733 6.22733C6.05647 6.39818 5.77946 6.39818 5.60861 6.22733L3.29297 3.91169L0.977328 6.22733C0.806474 6.39818 0.529464 6.39818 0.35861 6.22733C0.187755 6.05647 0.187755 5.77946 0.35861 5.60861L2.67425 3.29297L0.35861 0.977328C0.187755 0.806474 0.187755 0.529464 0.35861 0.35861Z"
							fill="currentColor"
						/>
					</svg>
				</button>
			</span>
			<span
				class="text-sm inline-flex items-center py-1 pl-3 pr-2 rounded-full bg-sienna-100 text-neutral-900 mr-2 shadow-input"
				v-if="filter?.day_care_class_id"
			>
				{{ filter?.className }}
				<button
					type="button"
					class="flex-shrink-0 ml-2 h-4 w-4 rounded-full inline-flex items-center justify-center text-neutral-700 hover:text-neutral-900"
					@click="filterSubmit({ day_care_class_id: null })"
				>
					<svg width="7" height="7" viewBox="0 0 7 7" fill="none">
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M0.35861 0.35861C0.529464 0.187755 0.806474 0.187755 0.977328 0.35861L3.29297 2.67425L5.60861 0.35861C5.77946 0.187755 6.05647 0.187755 6.22733 0.35861C6.39818 0.529464 6.39818 0.806474 6.22733 0.977328L3.91169 3.29297L6.22733 5.60861C6.39818 5.77946 6.39818 6.05647 6.22733 6.22733C6.05647 6.39818 5.77946 6.39818 5.60861 6.22733L3.29297 3.91169L0.977328 6.22733C0.806474 6.39818 0.529464 6.39818 0.35861 6.22733C0.187755 6.05647 0.187755 5.77946 0.35861 5.60861L2.67425 3.29297L0.35861 0.977328C0.187755 0.806474 0.187755 0.529464 0.35861 0.35861Z"
							fill="currentColor"
						/>
					</svg>
				</button>
			</span>
		</div>
		<div
			class="__report-lesson__container"
			v-if="tabSelected === 0 && timeTable && timeTable.length > 0"
		>
			<div class="shadow-sm sm:rounded-2xl overflow-hidden">
				<div class="__record__table overflow-x-auto scroll-bar">
					<div
						class="overflow-hidden sm:rounded-t-2xl w-fit min-w-full"
					>
						<table class="min-w-full divide-y text-neutral-200">
							<thead class="bg-neutral-100 h-16">
								<tr>
									<th
										scope="col"
										class="px-3 py-3 text-center text-xs font-semibold text-neutral-600 uppercase tracking-wider w-16 whitespace-nowrap"
									>
										STT
									</th>
									<th
										scope="col"
										class="px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
									>
										ID
									</th>
									<th
										scope="col"
										class="px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
									>
										Thời gian dạy
									</th>
									<th
										scope="col"
										class="px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
									>
										Trạng thái
									</th>
									<th
										scope="col"
										class="px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
									>
										NGƯỜI TẠO
									</th>
								</tr>
							</thead>
							<tbody>
								<tr
									@click="showDetail(item.id)"
									v-for="(item, index) in timeTable"
									:key="item.id"
									:class="
										index % 2 === 0
											? 'bg-white'
											: 'bg-neutral-50'
									"
									class="text-neutral-700 cursor-pointer hover:bg-orange-50"
								>
									<td>
										<div
											class="px-3 py-4 text-center text-neutral-700"
										>
											{{ index + 1 }}
										</div>
									</td>
									<td
										class="px-3 py-4 whitespace-nowrap text-neutral-700"
									>
										<div>
											Thời khoá biểu {{ item?.order }}
										</div>
									</td>
									<td
										class="px-3 py-4 whitespace-nowrap text-neutral-700"
									>
										<div>
											<span v-if="!item.activated_date"
												>Từ</span
											>
											{{
												$filters.formatDate2(
													item.activated_date
												)
											}}
											-
											<span v-if="item.deactivated_date">
												{{
													$filters.formatDate2(
														item.deactivated_date
													)
												}}
												<span
													v-if="item.deactivated_date"
												>
													({{
														item?.duration_in_days
													}}
													ngày)
												</span>
											</span>
										</div>
									</td>
									<td
										class="px-3 py-4 whitespace-nowrap text-neutral-700"
									>
										<div>
											<div
												v-if="item?.state === 'future'"
												class="flex items-center"
											>
												<svg
													class="mr-2"
													width="21"
													height="20"
													viewBox="0 0 21 20"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														fill-rule="evenodd"
														clip-rule="evenodd"
														d="M10.5 20C16.0228 20 20.5 15.5228 20.5 10C20.5 4.47715 16.0228 0 10.5 0C4.97715 0 0.5 4.47715 0.5 10C0.5 15.5228 4.97715 20 10.5 20ZM6.33333 9.16667C5.98816 9.16667 5.70833 9.53976 5.70833 10C5.70833 10.4602 5.98816 10.8333 6.33333 10.8333H15.0833C15.4285 10.8333 15.7083 10.4602 15.7083 10C15.7083 9.53976 15.4285 9.16667 15.0833 9.16667H6.33333Z"
														fill="#CBD5E1"
													/>
												</svg>

												Dự kiến
											</div>
											<div
												v-if="item?.state === 'past'"
												class="flex items-center"
											>
												<svg
													class="mr-2"
													width="20"
													height="20"
													viewBox="0 0 20 20"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														fill-rule="evenodd"
														clip-rule="evenodd"
														d="M11.2125 6.21209C11.5786 5.84597 12.1722 5.84597 12.5384 6.21209C12.9 6.57371 12.9044 7.15727 12.5517 7.52434L7.56141 13.7622C7.5542 13.7712 7.54651 13.7798 7.53835 13.7879C7.17224 14.154 6.57865 14.154 6.21253 13.7879L2.90447 10.4799C2.53835 10.1137 2.53835 9.52015 2.90447 9.15403C3.27059 8.78791 3.86418 8.78791 4.2303 9.15403L6.8472 11.7709L11.1877 6.24013C11.1954 6.23029 11.2037 6.22093 11.2125 6.21209Z"
														fill="#94A3B8"
													/>
													<path
														fill-rule="evenodd"
														clip-rule="evenodd"
														d="M10.062 12.6374L11.2125 13.7879C11.5786 14.154 12.1722 14.154 12.5384 13.7879C12.5465 13.7798 12.5542 13.7712 12.5614 13.7622L17.5517 7.52434C17.9044 7.15727 17.9 6.57371 17.5384 6.21209C17.1722 5.84597 16.5786 5.84597 16.2125 6.21209C16.2037 6.22093 16.1954 6.23029 16.1877 6.24013L11.8472 11.7709L11.2405 11.1642L10.062 12.6374Z"
														fill="#94A3B8"
													/>
												</svg>
												Đã dạy
											</div>
											<div
												v-if="item?.state === 'active'"
												class="flex items-center"
											>
												<svg
													class="mr-2"
													width="20"
													height="20"
													viewBox="0 0 20 20"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														fill-rule="evenodd"
														clip-rule="evenodd"
														d="M11.2125 6.21209C11.5786 5.84597 12.1722 5.84597 12.5384 6.21209C12.9 6.57371 12.9044 7.15727 12.5517 7.52434L7.56141 13.7622C7.5542 13.7712 7.54651 13.7798 7.53835 13.7879C7.17224 14.154 6.57865 14.154 6.21253 13.7879L2.90447 10.4799C2.53835 10.1137 2.53835 9.52015 2.90447 9.15403C3.27059 8.78791 3.86418 8.78791 4.2303 9.15403L6.8472 11.7709L11.1877 6.24013C11.1954 6.23029 11.2037 6.22093 11.2125 6.21209Z"
														fill="#2AA797"
													/>
													<path
														fill-rule="evenodd"
														clip-rule="evenodd"
														d="M10.062 12.6374L11.2125 13.7879C11.5786 14.154 12.1722 14.154 12.5384 13.7879C12.5465 13.7798 12.5542 13.7712 12.5614 13.7622L17.5517 7.52434C17.9044 7.15727 17.9 6.57371 17.5384 6.21209C17.1722 5.84597 16.5786 5.84597 16.2125 6.21209C16.2037 6.22093 16.1954 6.23029 16.1877 6.24013L11.8472 11.7709L11.2405 11.1642L10.062 12.6374Z"
														fill="#2AA797"
													/>
												</svg>
												Hiện tại
											</div>
										</div>
									</td>
									<td
										class="px-3 py-4 whitespace-nowrap text-neutral-700"
									>
										<div
											@click.stop="
												$router.push({
													name: routerName.RECORD_EMPLOYEE_DETAIL,
													params: {
														id: item
															.created_by_staff
															.id,
													},
												})
											"
											class="flex items-center"
											v-if="item.created_by_staff"
										>
											<div>
												<img
													class="shadow-sm inline-block h-6 w-6 rounded-full"
													:src="
														item.created_by_staff
															?.profile_photo
															?.w200
													"
													alt=""
													v-if="
														item.created_by_staff
															?.profile_photo
															?.w200
													"
												/>
												<span
													v-else
													class="inline-flex items-center justify-center h-6 w-6 rounded-full"
													:style="{
														background:
															item
																.created_by_staff
																?.profile_photo
																?.default
																?.color,
													}"
												>
													<span
														class="font-medium leading-none text-white text-xs"
														>{{
															item
																.created_by_staff
																?.profile_photo
																?.default
																?.initial
														}}</span
													>
												</span>
											</div>
											<div
												class="ml-4 text-blue-600 font-semibold whitespace-pre-wrap w-40"
											>
												{{ item.created_by_staff.name }}
											</div>
										</div>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
		<div class="__report-lesson__container" v-else-if="tabSelected === 1">
			<div
				v-for="group in timeSlotByYear"
				:key="group.year"
				class="mb-10"
			>
				<div class="text-neutral-600 font-semibold text-2xl mb-4">
					Năm {{ group.year }}
				</div>
				<div class="shadow-sm sm:rounded-2xl overflow-hidden">
					<div class="__record__table overflow-x-auto scroll-bar">
						<div
							class="overflow-hidden sm:rounded-t-2xl w-fit min-w-full"
						>
							<table class="min-w-full divide-y text-neutral-200">
								<thead class="bg-neutral-100 h-16">
									<tr>
										<th
											scope="col"
											class="px-3 py-3 text-center text-xs font-semibold text-neutral-600 uppercase tracking-wider w-16 whitespace-nowrap"
										>
											STT
										</th>
										<th
											scope="col"
											class="px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
										>
											TKB của học sinh
										</th>
										<th
											scope="col"
											class="px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
										>
											Ngày chỉnh sửa
										</th>
										<th
											scope="col"
											class="px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
										>
											Ngày áp dụng
										</th>
										<th
											scope="col"
											class="px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap cursor-pointer"
										>
											Trạng thái
										</th>
										<th
											scope="col"
											class="px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
										>
											Người chỉnh sửa
										</th>
										<th
											scope="col"
											class="px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
										></th>
									</tr>
								</thead>
								<tbody>
									<tr
										v-for="(item, index) in group.items"
										:key="index"
										class="text-neutral-700 hover:bg-orange-50"
									>
										<td>
											<div
												class="px-3 py-4 text-center text-neutral-700"
											>
												{{ index + 1 }}
											</div>
										</td>
										<td
											class="px-3 py-4 whitespace-nowrap text-neutral-700"
										>
											<div
												class="flex items-center"
											>
												<div>
													<img
														class="shadow-sm inline-block h-6 w-6 rounded-full"
														:src="
															getStudent(
																item.student_id
															)?.profile_photo
																?.w200
														"
														alt=""
														v-if="
															getStudent(
																item.student_id
															)?.profile_photo
																?.w200
														"
													/>
													<span
														v-else
														class="inline-flex items-center justify-center h-6 w-6 rounded-full"
														:style="{
															background:
																getStudent(
																	item.student_id
																)?.profile_photo
																	?.default
																	?.color,
														}"
													>
														<span
															class="font-medium leading-none text-white text-xs"
															>{{
																getStudent(
																	item.student_id
																)?.profile_photo
																	?.default
																	?.initial
															}}</span
														>
													</span>
												</div>
												<div
													class="ml-4 text-yellow-700 font-semibold whitespace-pre-wrap"
												>
													{{
														getStudent(
															item.student_id
														)?.name
													}}
												</div>
											</div>
										</td>
										<td
											class="px-3 py-4 whitespace-nowrap text-neutral-700"
										>
											<div>
												{{
													$filters.formatDate2(
														item.inserted_at
													)
												}}
											</div>
										</td>
										<td
											class="px-3 py-4 whitespace-nowrap text-neutral-700"
										>
											<div>
												<span
													v-if="!item.activated_date"
													>Từ</span
												>
												{{
													$filters.formatDate2(
														item.activated_date
													)
												}}

												<span
													v-if="item.deactivated_date"
												>
													-
													{{
														$filters.formatDate2(
															item.deactivated_date
														)
													}}
													<span
														v-if="
															item.duration_in_days
														"
													>
														({{
															item?.duration_in_days
														}}
														ngày)
													</span>
												</span>
											</div>
										</td>
										<td
											class="px-3 py-4 whitespace-nowrap text-neutral-700"
										>
											<div
												v-if="item?.state === 'future'"
												class="flex items-center"
											>
												<svg
													class="mr-2"
													width="21"
													height="20"
													viewBox="0 0 21 20"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														fill-rule="evenodd"
														clip-rule="evenodd"
														d="M10.5 20C16.0228 20 20.5 15.5228 20.5 10C20.5 4.47715 16.0228 0 10.5 0C4.97715 0 0.5 4.47715 0.5 10C0.5 15.5228 4.97715 20 10.5 20ZM6.33333 9.16667C5.98816 9.16667 5.70833 9.53976 5.70833 10C5.70833 10.4602 5.98816 10.8333 6.33333 10.8333H15.0833C15.4285 10.8333 15.7083 10.4602 15.7083 10C15.7083 9.53976 15.4285 9.16667 15.0833 9.16667H6.33333Z"
														fill="#CBD5E1"
													/>
												</svg>
												Dự kiến
											</div>
											<div
												v-if="
													item?.state === 'activated'
												"
												class="flex items-center"
											>
												<svg
													class="mr-2"
													width="20"
													height="20"
													viewBox="0 0 20 20"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														fill-rule="evenodd"
														clip-rule="evenodd"
														d="M11.2125 6.21209C11.5786 5.84597 12.1722 5.84597 12.5384 6.21209C12.9 6.57371 12.9044 7.15727 12.5517 7.52434L7.56141 13.7622C7.5542 13.7712 7.54651 13.7798 7.53835 13.7879C7.17224 14.154 6.57865 14.154 6.21253 13.7879L2.90447 10.4799C2.53835 10.1137 2.53835 9.52015 2.90447 9.15403C3.27059 8.78791 3.86418 8.78791 4.2303 9.15403L6.8472 11.7709L11.1877 6.24013C11.1954 6.23029 11.2037 6.22093 11.2125 6.21209Z"
														fill="#2AA797"
													/>
													<path
														fill-rule="evenodd"
														clip-rule="evenodd"
														d="M10.062 12.6374L11.2125 13.7879C11.5786 14.154 12.1722 14.154 12.5384 13.7879C12.5465 13.7798 12.5542 13.7712 12.5614 13.7622L17.5517 7.52434C17.9044 7.15727 17.9 6.57371 17.5384 6.21209C17.1722 5.84597 16.5786 5.84597 16.2125 6.21209C16.2037 6.22093 16.1954 6.23029 16.1877 6.24013L11.8472 11.7709L11.2405 11.1642L10.062 12.6374Z"
														fill="#2AA797"
													/>
												</svg>
												Hiện tại
											</div>
											<div
												v-if="item?.state === 'deactivated'"
												class="flex items-center"
											>
												<svg
													class="mr-2"
													width="20"
													height="20"
													viewBox="0 0 20 20"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														fill-rule="evenodd"
														clip-rule="evenodd"
														d="M11.2125 6.21209C11.5786 5.84597 12.1722 5.84597 12.5384 6.21209C12.9 6.57371 12.9044 7.15727 12.5517 7.52434L7.56141 13.7622C7.5542 13.7712 7.54651 13.7798 7.53835 13.7879C7.17224 14.154 6.57865 14.154 6.21253 13.7879L2.90447 10.4799C2.53835 10.1137 2.53835 9.52015 2.90447 9.15403C3.27059 8.78791 3.86418 8.78791 4.2303 9.15403L6.8472 11.7709L11.1877 6.24013C11.1954 6.23029 11.2037 6.22093 11.2125 6.21209Z"
														fill="#94A3B8"
													/>
													<path
														fill-rule="evenodd"
														clip-rule="evenodd"
														d="M10.062 12.6374L11.2125 13.7879C11.5786 14.154 12.1722 14.154 12.5384 13.7879C12.5465 13.7798 12.5542 13.7712 12.5614 13.7622L17.5517 7.52434C17.9044 7.15727 17.9 6.57371 17.5384 6.21209C17.1722 5.84597 16.5786 5.84597 16.2125 6.21209C16.2037 6.22093 16.1954 6.23029 16.1877 6.24013L11.8472 11.7709L11.2405 11.1642L10.062 12.6374Z"
														fill="#94A3B8"
													/>
												</svg>
												Kết thúc
											</div>
										</td>
										<td
											class="px-3 py-4 whitespace-nowrap text-neutral-700"
										>
											<div
												class="flex items-center cursor-pointer"
												v-if="item?.created_by_staff_id"
											>
												<div>
													<img
														class="shadow-sm inline-block h-6 w-6 rounded-full"
														:src="
															getStaff(
																item?.created_by_staff_id
															)?.profile_photo
																?.w200
														"
														alt=""
														v-if="
															getStaff(
																item?.created_by_staff_id
															)?.profile_photo
																?.w200
														"
													/>
													<span
														v-else
														class="inline-flex items-center justify-center h-6 w-6 rounded-full"
														:style="{
															background:
																getStaff(
																	item?.created_by_staff_id
																)?.profile_photo
																	?.default
																	?.color,
														}"
													>
														<span
															class="font-medium leading-none text-white text-xs"
															>{{
																getStaff(
																	item?.created_by_staff_id
																)?.profile_photo
																	?.default
																	?.initial
															}}</span
														>
													</span>
												</div>
												<div
													class="ml-4 text-blue-600 font-semibold whitespace-pre-wrap w-40"
												>
													{{
														getStaff(item?.created_by_staff_id)?.name
													}}
												</div>
											</div>
										</td>
										<td
											class="px-3 py-4 whitespace-nowrap text-right"
										>
											<div
												class="text-yellow-700 font-semibold cursor-pointer whitespace-nowrap"
												@click="goToStudent(item)"
											>
												Xem ngay
											</div>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
			<div
				v-if="!timeSlotByYear.length && stopLoad"
				class="w-full h-full flex items-center justify-center flex-col"
			>
				<img
					src="@/assets/images/illustrations/not_found.png"
					alt=""
					height="250"
					width="250"
				/>
				<div
					class="text-neutral-500 text-lg text-center"
					style="max-width: 700px"
				>
					Không có thời khoá biểu
				</div>
			</div>
			<DaInfinityLoading
				:loaded="stopLoad"
				:is-loading="isFetching"
				@infinite-load="fetchTimeSlot"
			/>
		</div>
		<div
			v-else
			class="w-full h-full flex items-center justify-center flex-col"
		>
			<img
				src="@/assets/images/illustrations/not_found.png"
				alt=""
				height="250"
				width="250"
			/>
			<div
				class="text-neutral-500 text-lg text-center"
				style="max-width: 700px"
			>
				Không có thời khoá biểu
			</div>
		</div>
	</div>
</template>

<script>
import { defineComponent } from 'vue';
import { $api } from '@/services';
import StatisticalTimeTable from '@/views/timetable/features/StatisticalTimeTable.vue';
import DaInfinityLoading from '@/components/common/daInfinityLoading/DaInfinityLoading.vue';
import { _ROUTER_NAME } from '@/enums';
import { scheduleKindFromRoute } from '@/helper/scheduleSection';
import ScheduleSectionNav from '@/components/modules/schedule/ScheduleSectionNav.vue';

export default defineComponent({
	name: 'TimeTableHistory',
	components: {
		StatisticalTimeTable,
		DaInfinityLoading,
		ScheduleSectionNav,
	},
	data() {
		return {
			timeTable: [],
			params: {},
			isShow: false,
			id: '',
			timeSlotByYear: [],
			beforeYear: null,
			stopLoad: false,
			isFetching: false,
			tabSelected:
				scheduleKindFromRoute(this.$route) === 'personal' ? 0 : 1,
			tabs: [
				{
					id: 0,
					name: 'Toàn trung tâm',
				},
				{
					id: 1,
					name: 'Một học sinh',
				},
			],
			sortStateAsc: true,
			staffMap: {},
			studentMap: {},
			fetchToken: 0,
		};
	},

	created() {
		this.loadHistory();
	},

	watch: {
		'$route.query.type'() {
			this.tabSelected = this.studentHistoryOnly ? 1 : 0;
			this.resetHistory();
			this.loadHistory();
		},
	},

	computed: {
		routerName() {
			return _ROUTER_NAME;
		},

		scheduleKind() {
			return scheduleKindFromRoute(this.$route);
		},

		historyTitle() {
			return {
				personal: 'Lịch sử TKB cá nhân',
				daycare: 'Lịch sử TKB bán trú',
				group: 'Lịch sử TKB nhóm',
			}[this.scheduleKind];
		},

		studentHistoryOnly() {
			return this.scheduleKind !== 'personal';
		},

		visibleTabs() {
			if (this.studentHistoryOnly) {
				return this.tabs.filter((tab) => tab.id === 1);
			}
			return this.tabs;
		},
	},

	methods: {
		loadHistory() {
			if (!this.studentHistoryOnly) this.fetchTimeTableHistory();
			this.fetchTimeSlot();
		},
		historyParams() {
			if (this.scheduleKind === 'personal') return {};
			return { type: this.scheduleKind };
		},

		resetHistory() {
			this.fetchToken += 1;
			this.timeTable = [];
			this.timeSlotByYear = [];
			this.beforeYear = null;
			this.stopLoad = false;
			this.isFetching = false;
			this.staffMap = {};
			this.studentMap = {};
		},

		async fetchTimeTableHistory() {
			const kind = this.scheduleKind;
			try {
				const res = await $api.schedule.fetchTimetableHistory({
					...this.params,
					...this.historyParams(),
				});
				if (kind !== this.scheduleKind) return;
				this.timeTable = res?.data?.data;
			} catch (e) {
				console.log(e);
			}
		},

		async fetchTimeSlot() {
			if (this.stopLoad || this.isFetching) return;

			const kind = this.scheduleKind;
			const token = this.fetchToken;
			this.isFetching = true;
			try {
				const res = await $api.org.listTimeSlot({
					...(this.beforeYear ? { before: this.beforeYear } : {}),
					...this.historyParams(),
				});
				if (kind !== this.scheduleKind || token !== this.fetchToken) {
					return;
				}
				const data = res?.data?.data || [];
				const year = res?.data?.year;

				this.staffMap = {
					...this.staffMap,
					...(res?.data?.staffs_map || {}),
				};
				this.studentMap = {
					...this.studentMap,
					...(res?.data?.students_map || {}),
				};

				if (!year || (this.beforeYear && year >= this.beforeYear)) {
					this.stopLoad = true;
					return;
				}

				if (data.length) {
					this.timeSlotByYear.push({ year, items: data });
				}
				this.beforeYear = year;
			} catch (e) {
				console.log(e);
			} finally {
				if (token === this.fetchToken) this.isFetching = false;
			}
		},

		getStaff(id) {
			return this.staffMap[id];
		},

		getStudent(id) {
			return this.studentMap[id];
		},

		showDetail(id) {
			this.id = id;
			this.isShow = true;
		},

		toggleSortState() {
			this.sortStateAsc = !this.sortStateAsc;
		},

		goToCurrentTimetable() {
			if (this.scheduleKind === 'group') {
				this.$router.push({
					name: this.routerName.SCHEDULE_TIMETABLE_GROUP_CLASSES,
				});
				return;
			}
			if (this.scheduleKind === 'daycare') {
				this.$router.push({
					name: this.routerName.SCHEDULE_TIMETABLE_CLASS,
					query: { type: 'daycare' },
				});
				return;
			}
			this.$router.push({
				name: this.routerName.SCHEDULE_TIMETABLE_CLASS,
			});
		},

		goToStudent(item) {
			const studentId = item?.student_id;
			if (!studentId) return;
			const deactivatedDate = item?.deactivated_date || undefined;
			const query = {
				activated_date: item?.activated_date,
				student: studentId,
				deactivated_date: deactivatedDate,
			};
			if (this.scheduleKind === 'group') {
				this.$router.push({
					name: this.routerName.SCHEDULE_TIMETABLE_GROUP_CLASSES,
					query,
				});
				return;
			}
			if (this.scheduleKind === 'daycare') {
				query.type = 'daycare';
			}
			this.$router.push({
				name: this.routerName.SCHEDULE_TIMETABLE_CLASS,
				query,
			});
		},
	},
});
</script>
